import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import MyRouter from './myrouter';
import { SettingsProvider } from './settings';
import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <SettingsProvider>
            <ThemeProvider theme={createTheme()}>
                <MyRouter />
            </ThemeProvider>
        </SettingsProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
